import React from "react";
import PropTypes from "prop-types";
import parse, { domToReact } from "html-react-parser";
import { trackPageLoad } from "asos-contentweb-analytics-middleware";
import isExternalLink from "src/utilities/isExternalLink";
import sdkProvider from "src/utilities/sdkProvider";
import analyticsProvider from "src/analyticsProvider";
import getUserLoginStatus from "src/utilities/getUserLoginStatus";
import getComponentStylesFromString from "src/app/utilities/getComponentStylesFromString";
import styles from "./HtmlContent.module.css";

export default function HtmlContent({ data, analytics }) {
  async function onClick(e) {
    const { innerText, target, href } = e.target;

    if (isExternalLink(href)) {
      e.preventDefault();

      const identity = await sdkProvider("identity");
      const isRecognised = (await identity.customer.isRecognised?.()) || false;
      const isAuthenticated = await identity.customer.isAuthenticated();
      const customerId = await identity.customer.customerId();
      const { articleName, category } = analytics;

      const config = analyticsProvider("external-link", {
        articleName,
        customerId,
        loginStatus: getUserLoginStatus({ isRecognised, isAuthenticated }),
        category,
        text: innerText,
      });

      trackPageLoad(config);
      window.open(href, target);
    }
  }

  const options = {
    replace: ({ name, children, attribs }) => {
      if (!attribs) return;

      if (name === "a") {
        const { style, ...rest } = attribs;
        return (
          /* eslint-disable-next-line */
          <a
            onClick={onClick}
            style={getComponentStylesFromString(style)}
            {...rest}
          >
            {domToReact(children, options)}
          </a>
        );
      }

      if (attribs.src) {
        const { style, ...rest } = attribs;

        return (
          <span className={styles.imageWrapper}>
            {
              <img
                style={getComponentStylesFromString(style)}
                {...rest}
                alt=""
              />
            }
          </span>
        );
      }
    },
  };

  const text = data?.text ?? false;

  if (!text) return null;

  return <div className={styles.content}>{parse(text, options)}</div>;
}

HtmlContent.propTypes = {
  data: PropTypes.object,
  analytics: PropTypes.shape({
    articleName: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
  }).isRequired,
};
